
    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CompleteEarlyResolutionProcessErpInstructions extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;
    
}
